import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';
import { ScrollArea } from 'components/Elements';
import { formatRelativeTime } from 'utils/formatRelativeTime';
import { HiDotsVertical } from 'react-icons/hi';

export const LiveLogFeed = () => {
  const [events, setEvents] = useState([]);

  // You can simulate fetching here later
  useEffect(() => {
    setEvents([]); // Simulate an empty fetch for now
  }, []);

  const groupedEvents = events.reduce((acc, curr) => {
    if (!acc[curr.groupKey]) acc[curr.groupKey] = [];
    acc[curr.groupKey].push(curr);
    return acc;
  }, {});

  return (
    <div className="w-full max-w-md">
      <div className="flex flex-row items-start justify-between mb-4">
        <div>
          <h2 className="text-white/90 font-semibold text-base">
            Wire24 API Logs
          </h2>
          <p className="text-white/40 text-xs">Most recent activities</p>
        </div>
        <HiDotsVertical />
      </div>

      <ScrollArea className="h-[32rem]">
        {events.length === 0 ? (
          <div className="h-full flex items-center justify-center text-white/40 text-sm">
            No logs available at the moment.
          </div>
        ) : (
          Object.entries(groupedEvents).map(([group, items]) => (
            <div key={group} className="mb-4">
              <div className="flex flex-col space-y-2">
                <AnimatePresence>
                  {items.map((event) => (
                    <motion.div
                      key={event.id}
                      initial={{ opacity: 0, y: 8 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -8 }}
                      transition={{ duration: 0.2 }}
                      className={clsx(
                        'rounded-xl px-3 py-1 backdrop-blur-md border border-white/10',
                        'hover:scale-[1.01] duration-200 transition cursor-pointer'
                      )}
                    >
                      <div className="flex justify-between items-center mb-0.5">
                        <span className="text-[8px] font-medium text-white/70">
                          {formatRelativeTime(event.timestamp)}
                        </span>
                        <span className="text-[8px] uppercase text-white/30">
                          {event.status}
                        </span>
                      </div>
                      <p className="text-[10px] text-white">{event.message}</p>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            </div>
          ))
        )}
      </ScrollArea>
    </div>
  );
};
